import React from 'react';
import Toggle from "components/Form/Toggle";
import MultiSelector from "components/Form/MultiSelector";
import {AttendanceFilter as AttendanceFilterSpec, EventFilter} from "types/AudienceCriteria";
import {useQuery} from "react-query";
import ngage from "services/ngage";
import {useOperator} from "context/OperatorContext";
import {DateTime} from "luxon";
import IconName from "types/IconName";
import {FormikHelpers} from "formik";
import {Item} from 'components/Form/MultiSelector/MultiSelector';

const eventFilterTemplate: EventFilter = {
    event_id: 0
}

type Props = {
    formik: FormikHelpers<any>
    groupIndex: number
    filter?: AttendanceFilterSpec | null
}

function AttendedFilter({formik, groupIndex, filter}: Props) {
    const {termFor} = useOperator()

    const {data: events, isLoading: eventsLoading} = useQuery(
        ['events.all', {page: 1, perPage: 1000}],
        () => ngage.events.all(1, 1000)
    )

    const selectableEvents = events?.data.map(event => ({
        id: event.id,
        name: event.name,
        description: `${event.starts_at.toLocaleString(DateTime.DATETIME_FULL)} (${event.type.name})`,
        icon: IconName.CALENDAR
    })) || []

    const selectedEvents = filter?.events.map(eventFilter => eventFilter.event_id)

    // Handle toggling this filter on and off
    const handleToggle = (checked: boolean): void => {
        formik.setFieldValue(
            `criteria.groups.${groupIndex}.filters.attendance`,
          checked ? {events: [{...eventFilterTemplate}]} : undefined
        )
    }

    // Handle selection of events
    const handleSelectEvents = (items?: Array<Item>): void => {
        formik.setFieldValue(
            `criteria.groups.${groupIndex}.filters.attendance.events`,
            items?.map(item => ({event_id: item.id}))
        )
    }

    return (
        <div className="mt-8">
            <div className="flex items-center">
                <Toggle
                    label="Attended"
                    checked={!!filter}
                    onChange={handleToggle}
                    loading={eventsLoading}
                    disabled={eventsLoading}
                />

                {!filter && <div className="font-medium text-gray-700">{termFor('events')}...</div>}
            </div>

            {filter &&
                <div className="mt-2 pl-14">
                    <MultiSelector
                        isLoading={eventsLoading}
                        items={selectableEvents}
                        selectedIds={selectedEvents}
                        onChange={handleSelectEvents}
                        required
                    />
                </div>
            }
        </div>
    );
}

export default AttendedFilter;